import Parse from "parse";

export const addNewCompanyCategoryName = (data) => {
    return Parse.Cloud.run("addNewCompanyCategoryName", data)
}